import type { HTMLAttributes, ReactNode } from 'react';

export interface CardProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
  /** Si vrai, applique un padding réduit (utile pour cartes denses) */
  compact?: boolean;
}

export const Card = ({ children, className = '', compact = false, ...rest }: CardProps) => (
  <div
    className={[
      'bg-zinc-900 border border-zinc-800 rounded-2xl',
      compact ? 'p-3' : 'p-4',
      className,
    ].filter(Boolean).join(' ')}
    {...rest}
  >
    {children}
  </div>
);
